<script>
import TheHeader from "@/components/index/TheHeader.vue";
export default {
  components: {
    TheHeader
  },
  computed: {
    hasAgentOptometristRole() {
      try {
        const roles = localStorage.getItem('roles');
        if (roles) {
          console.log('角色信息:', roles);
          // 检查角色数组是否包含ROLE_AGENT_OPTOMETRIST
          return roles.split(",").includes('ROLE_AGENT_OPTOMETRIST');
        }
        return false;
      } catch (error) {
        console.error('解析角色信息失败:', error);
        return false;
      }
    }
  }
};
</script>

<template>
  <div class="Index" id="content" >
    <TheHeader />
    <div class="mainContent">
      <div class="content" >
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Index {
  display: flex;
  height: 100vh;
  flex-direction: column;
  .mainContent {
    flex-grow: 1;
    display: flex;
    width: 100vw;
    background:#f5f6f7;
    .content {
      width: calc(100vw - 200px - 30px - 50px);
      height: calc(100vh - 65px - 30px);
      box-sizing: border-box;
      flex-grow: 1;
      margin: 15px;
      background:rgba(248,248,248,1);
      border-radius: 5px;
      overflow: auto;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/index/Index.vue